export default __webpack_public_path__ + "static/media/template.6d819e16.png";